import React, { useState, useRef } from "react";
import Button from "../../../../Elements/Button/Button.js";
import Icon from "../../../../Elements/Icon/Icon.tsx";
import Datepicker from "./Datepicker/Datepicker.js";
import GetTransformedDate from "../../../../../utils/dateViewTransformer.tsx";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useContent } from "../../../../../contexts/contentContext/contentContext.js";

const ReportsInputs = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  dynamicFormsList,
  selectedFormArray,
  setSelectedFormArray,
  setshowFormsList,
  selectedFormNameArray,
  setSelectedFormNameArray,
  showData,
  setAllTime,
  allTime,
  displayDatepicker,
  setDisplayDatepicker,
  setCurrentPage,
  showFormsList,
  handleChangeSelectedArray,
  exportMails,
  setExportMails,
  loading,
  setShowStatusesList,
}) => {
  const myRef = useRef(null);
  const [selectAllForms, setSelectAllForms] = useState(false);
  const { getTextByKey, getDirection } = useContent();
  const displayDatesStatus = () => {
    if (startDate && endDate) {
      let yesterday = new Date();
      let today = new Date();
      yesterday.setDate(today.getDate() - 1);
      if (
        convertDate(startDate) === convertDate(endDate) &&
        convertDate(endDate) === convertDate(today)
      ) {
        return <span className="blue">{getTextByKey("datepicker-today")}</span>;
      } else if (
        convertDate(endDate) === convertDate(today) &&
        convertDate(startDate) === convertDate(yesterday)
      ) {
        return (
          <span className="blue">{getTextByKey("datepicker-yesterday")}</span>
        );
      } else {
        return (
          <span className="blue">
            <GetTransformedDate
              date={startDate}
              fullView={true}
              showDay={false}
              showTime={false}
            />{" "}
            -{" "}
            <GetTransformedDate
              date={endDate}
              fullView={true}
              showDay={false}
              showTime={false}
            />
          </span>
        );
      }
    } else {
      return getTextByKey("datepicker-select-date");
    }
  };

  function convertDate(date) {
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    var mmChars = mm.split("");
    var ddChars = dd.split("");
    return (
      yyyy +
      "-" +
      (mmChars[1] ? mm : "0" + mmChars[0]) +
      "-" +
      (ddChars[1] ? dd : "0" + ddChars[0])
    );
  }
  const selectAllFormsFunction = () => {
    setSelectAllForms((prev) => !prev);
    let tempAllformsArray = [];
    let tempAllformsArrayName = [];
    tempAllformsArray = dynamicFormsList.map((item) => item.Embed_Dynamic_Id);
    tempAllformsArrayName = dynamicFormsList.map(
      (item) => item.Embed_Dynamic_Inner_Title
    );
    setSelectedFormArray(tempAllformsArray);
    setSelectedFormNameArray(tempAllformsArrayName);
  };
  const clearInputs = () => {
    setExportMails(null);
    setSelectedFormNameArray([]);
    setSelectedFormArray([]);
    setStartDate(null);
    setEndDate(null);
    setCurrentPage(1);
    setAllTime(false);
    setSelectAllForms(false);
  };

  const openDatepicker = () => {
    const statusDatepicker = displayDatepicker;
    if (statusDatepicker) {
      setDisplayDatepicker(false);
      //setStartDate(null);
      //setEndDate(null);
    } else {
      setDisplayDatepicker(true);
    }
    setshowFormsList(false);
    setShowStatusesList(null);
  };
  return (
    <>
      <div className="sub-title-text">
        {getTextByKey("activity-reports-sub-title")}
      </div>
      <div className="activity-inputs">
        <div className="date">
          <div
            className="choose-date"
            onClick={() => {
              openDatepicker();
            }}
          >
            <Icon name="calendar" iconClass="calendar-icon" />
            <div className="selected-dates">
              <span className="date-title">{getTextByKey("date")}:</span>{" "}
              <span className="dates-selected">{displayDatesStatus()}</span>
              <Icon name="arrow-down-solid" small />
            </div>
          </div>
          <div className="date-picker-container" ref={myRef}>
            {displayDatepicker && (
              <Datepicker
                setDisplayDatepicker={setDisplayDatepicker}
                allTime={allTime}
                setAllTime={setAllTime}
                startDate={startDate}
                endDate={endDate}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
              />
            )}
          </div>
        </div>
        <div className="form">
          <div
            onClick={() => {
              setDisplayDatepicker(false);
              setShowStatusesList(null);
              setshowFormsList((prev) => !prev);
            }}
            className="choose-forms"
          >
            <Icon name="form" />
            <span className="form-title">
              {getTextByKey("embed-export-form")}:
            </span>
            {dynamicFormsList && dynamicFormsList.length > 0 && (
              <div className="placeholder-select-list">
                {selectedFormArray.length === 0 ? (
                  <span className="default-title">
                    {getTextByKey("select-form-embed")}
                  </span>
                ) : selectedFormArray.length === 1 ? (
                  selectedFormNameArray[0]
                ) : selectedFormArray.length === dynamicFormsList.length ? (
                  getTextByKey("all-forms-selected")
                ) : (
                  selectedFormArray.length +
                  " " +
                  getTextByKey("forms-selected")
                )}
                <Icon name="arrow-down-solid" small />
              </div>
            )}
          </div>

          {showFormsList ? (
            <div
              className={`forms-modal-list ${
                getDirection() === "rtl" ? "list-rtl" : ""
              }`}
            >
              <div className="forms-modal-header">
                <p className="title">{getTextByKey("select-form-embed")}</p>
                {selectedFormArray.length > 0 && (
                  <span
                    className="clear-forms"
                    onClick={() => {
                      setSelectedFormNameArray([]);
                      setSelectedFormArray([]);
                      setSelectAllForms(false);
                    }}
                  >
                    {getTextByKey("clear-inputs")}
                  </span>
                )}
              </div>
              <ul className="forms-list">
                {dynamicFormsList.map((item, i) => (
                  <li
                    key={i}
                    value={item.Embed_Dynamic_Id}
                    onClick={() => handleChangeSelectedArray(item)}
                  >
                    <div
                      className={`item ${
                        selectedFormArray.includes(item.Embed_Dynamic_Id)
                          ? "active-item"
                          : ""
                      }`}
                    >
                      {item.Embed_Dynamic_Inner_Title}{" "}
                      {selectedFormArray.includes(item.Embed_Dynamic_Id) ? (
                        <Icon name="check" iconClass="active-item-icon" />
                      ) : null}
                    </div>
                  </li>
                ))}
                <li
                  className="selectAll"
                  onClick={() => {
                    selectAllFormsFunction();
                  }}
                >
                  <div
                    className={`item ${selectAllForms ? "active-item" : ""}`}
                  >
                    {getTextByKey("all-forms")}
                    {selectAllForms && (
                      <Icon name="check" iconClass="active-item-icon" />
                    )}
                  </div>
                </li>
              </ul>
              <div
                onClick={() => {
                  setshowFormsList(false);
                }}
                className="submit-button-list"
              >
                {getTextByKey("ok")}
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className="activity-report-buttons">
        {selectedFormArray.length > 0 &&
        startDate !== endDate &&
        startDate <= endDate ? (
          <div className="show-data">
            <Button
              onClick={() => {
                showData(1);
                setCurrentPage(1);
              }}
            >
              {loading ? (
                <LoadingImageElement />
              ) : (
                getTextByKey("embed-export-submit")
              )}
            </Button>
          </div>
        ) : null}
        {exportMails && (
          <div className="clear-inputs">
            <Button
              buttonClass="clear-inputs-btn"
              onClick={() => {
                clearInputs();
              }}
            >
              {getTextByKey("clear-inputs")}
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default ReportsInputs;
